export default __webpack_public_path__ + "static/media/hashnode.dc39d50f.svg";